var get_array_doc = [];
// var People,spills,counters,appliances,dishes,windows,kids,Mirrors,highchair,bathroom,Couch_1,Couch_2,Couch_3,Couch_4,Couch_5,Couch_6;
function step2check() {
  if ($('input.step-2__checkbox').is( ":checked" )) {
    $('.btn-next').removeAttr("disabled");
  }else{
    $('.btn-next').prop("disabled", true);     
  } 
  
}
$(document).ready(function(){ 

  
  
  if($('body').hasClass('page-quiz')){
    var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
    if ( historyTraversal ) {
      // Handle page restore.      
      window.location.reload();
    }
  }
var $peoples = $( "input:radio[name='people']" );
var   $items = $( "input:checkbox[name='items']" );
var obj_1 = {};
  $peoples.on( "change", function() {
     var people = $(this).val().trim();
     $('.people__image').removeClass('active');
     $('.people__image-'+ people).addClass('active');
     $('.btn-next').removeAttr("disabled");    
    if(people == '3-4'){
      $('.get_qty').val('3');      
      People = '3';
    }else if(people == '5+' ){
      $('.get_qty').val('4');
      People = '4';      
    }else{
      $('.get_qty').val(people);
      People = people;
    }
    
  });
  var get_value = [];
  
  $items.on( "change", function() {
    var get_use = $(this).val();     
    if($(this).is(':checked')){
      get_value.push(get_use);      
    }else{
      var arr = get_value;
      var itemtoRemove = get_use;
      arr.splice($.inArray(itemtoRemove, arr), 1);       
    }    
    get_array_doc.push()
    $('.get_type').val(get_value);
    $('.get_type').val
    step2check();
    if(get_value.indexOf('spills') !== -1  ){
       spills = '1';
     }else{
       spills = '0';
     } 
     if(get_value.indexOf('counters') !== -1  ){
       counters = '1';
     }else{
       counters = '0';
     }
    if(get_value.indexOf('appliances') !== -1  ){
       appliances = '1';
     }else{
       appliances = '0';
     }
    if(get_value.indexOf('dishes') !== -1  ){
       dishes = '1';
     }else{
       dishes = '0';
     }
    if(get_value.indexOf('windows') !== -1  ){
       windows = '1';
    }else{
       windows = '0';
    }    
    if(get_value.indexOf('messy-kids') !== -1  ){
       kids = '1';
    }else{
       kids = '0';
    }
    if(get_value.indexOf('glass-mirrors') !== -1  ){
       Mirrors = '1';
    }else{
       Mirrors = '0';
    }
    if(get_value.indexOf('highchair') !== -1  ){
       highchair = '1';
    }else{
       highchair = '0';
    }
    if(get_value.indexOf('bathroom') !== -1  ){
       bathroom = '1';
    }else{
       bathroom = '0';
    }    
  });
var get_array = [];
  $('.btn-next').on('click',function(e){
        window.scrollTo({ top: 0, behavior: 'smooth' });
  if ($(".quiz-step__2").hasClass("active")) {
    $('.quiz-step__2').removeClass('active');
    $('.quiz-step__3').addClass('active');
    $('.control_number__item-3').addClass('active');
    $('.btn-next').prop("disabled", true);     
  }
  if ($(".quiz-step__1").hasClass("active")) {
     $('.quiz-step__1').removeClass('active');
     $('.quiz-step__2').addClass('active');
     $('.control_number__item-2').addClass('active');
     step2check();
  }
  
  })
 
  $('.btn-back').on('click',function(e){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if ($(".quiz-step__1").hasClass("active")) {
      $('#quizContainer').removeClass('show_step');      
    }
  
    if ($(".quiz-step__2").hasClass("active")) {
      $('.quiz-step__2').removeClass('active');
      $('.control_number__item-2').removeClass('active');
      $('.quiz-step__1').addClass('active');
    }
    if ($(".quiz-step__3").hasClass("active")) {
      $('.quiz-step__3').removeClass('active');
      $('.control_number__item-3').removeClass('active');
      $('.quiz-step__2').addClass('active');
      $('.step-3__option').removeClass('active');
      $('.step-3__option--first').addClass('active');
    }        
  $('.btn-next').removeAttr("disabled");
  
  })
  
  $('.purchase-option').on('click',function(e){
      $('.purchase-option').removeClass('active');
    $(this).addClass('active');
  })
   $('#calculate-btn').on('click',function(e){
    $(this).closest('#calculating').removeClass('showed');    
    $('#quizContainer').hide();     
    var get_name = $('#name-input').val();
    var get_arr = [],unique = [];
    var get_quantity = parseInt($('.get_qty').val()),get_price = 0,count_product = 0,get_subscription_price=0.00;
    var get_type_val = $('.get_type').val().split(',');    
    var get_add = false,count_hook=0;
    var People = get_quantity;    
     if(get_type_val.indexOf('spills') !== -1 || get_type_val.indexOf('counters') !== -1|| get_type_val.indexOf('appliances')!== -1 ){       
       var get_units = parseInt($('.spills_unit').attr('value'));
       count_product = count_product + get_units;            
     }
     if(get_type_val.indexOf('dishes')!== -1){       
       var get_units_dishes = parseInt($('.dishes_unit').attr('value'));
       count_product = count_product + get_units_dishes;       
     }
     if(get_type_val.indexOf('messy-kids')!== -1 || get_type_val.indexOf('highchair')!== -1){ 
       var get_units_messy = parseInt($('.messey_unit').attr('value'));
       count_product = count_product + get_units_messy;                
     }     
     if(get_type_val.indexOf('bathroom')!== -1){       
       if( get_quantity == 1 ){   
         var get_unit_bathroom =  parseInt($('.bathroom_unit_1').attr('value'));
         count_product = count_product + get_unit_bathroom;                   
       }
       if( get_quantity == 2 ){         
         var get_unit_bathroom =  parseInt($('.bathroom_unit_2').attr('value'));
         count_product = count_product + get_unit_bathroom;                   
       }
       if( get_quantity == 3 ){
         var get_unit_bathroom =  parseInt($('.bathroom_unit_3').attr('value'));
         count_product = count_product + get_unit_bathroom;                   
       }
       if( get_quantity >= 4 ){
         var get_unit_bathroom =  parseInt($('.bathroom_unit_4').attr('value'));
         count_product = count_product + get_unit_bathroom;                   
       }
       
     }      
     console.log(count_product,'count_productcount_product');
     if(get_quantity < 3){
        var get_selling_plan = '4';
     }else{
       var get_selling_plan = '3';
     }                
     var get_date = $('#quizContainer').attr('data-time');     
     $.ajax({       
         url: "https://script.google.com/macros/s/AKfycbwtHbMf0YNpM7VXEpDRsuI-FqGssaMzgjCq5ZxPogsoK62kfVMDo2i4sF61Rd1e6hDl/exec",
         type: "POST",
         data: {'Date':get_date,'# of People ':People,'Spills':spills,'Counters':counters,'Appliances':appliances,'Dishes':dishes,'Windows':windows,'Messy Kids':kids,'Glass/Mirrors':Mirrors,'Highchair':highchair,'Bathroom':bathroom,'Couch 1':Couch_1,'Couch 2':Couch_2,'Couch 3':Couch_3,'Couch 4':Couch_4,'Couch 5':Couch_5,'Couch 6':Couch_6},
         contentType: "application/javascript",
         dataType: 'jsonp',  
         success: function(resultData){
           console.log('success');                  
         },
         error:function(error) { console.log(error) }
      });
     $('.your-plan__heading').html(get_selling_plan +'-month subscription');
     $('.your-plan__item:first strong').html(get_selling_plan +' months!');
    var mf = $('#quizContainer').attr('data-money-format');
    var sum_add = 0;          
     var count = 0,pro_arr=[];           
     var get_count_length =parseInt($('.get_value:checked').length);
     if($('.get_value:checked').length > 1 && count_product > 1 ){        
       var get_length = Math.ceil(count_product/get_count_length);            
     }else{
       var get_length = count_product;            
     }     
     var get_length_clean = 0; 
      $('.get_value:checked').each(function(){         
         var get_handle_each = $(this).val().split(',')         
        get_length_clean = get_length_clean + get_handle_each.length;
         for(var j=0;j<get_handle_each.length;j++){                                
           if(j <= get_length - 1 && count < count_product ){
             pro_arr.push(get_handle_each[j]);
             count ++;
           }           
         }         
      })          
     if(pro_arr.length > 0){         
        var get_handle = pro_arr,product_count=0,count_quantity=0; 
       var get_length_checked = parseInt( $('.get_value:checked').length);                       
        var get_count_length_pro = Math.round(count_product/get_length_checked);                  
        var count = 0;
        for(var i=0;i<get_handle.length;i++){             
            var get_hamdle_prop = get_handle[i],get_array = get_handle.length;                                
              if(i <= get_count_length_pro - 1 && get_handle.length < count_product ){     
                console.log('====innnn');
              $.ajax({
               url: "/products/"+ get_handle[i] +"?view=ajax-quiz",
                type: "GET",                   
                contentType: "application/javascript",
                dataType : 'html', 
                async: true,
                success: function(data){ 
                  var get_handle_pro = $(data).attr('data-handle'),get_final_qty =[],get_final_qty_sub_get=[];                  
                    for(var i=0;i<get_handle.length;i++){
                      if(typeof get_difference_checker == 'undefined'){                
                        get_diff = count_product;                
                      }else{
                        get_diff = get__final;                              
                      }                                 
                      if(typeof get__final == 'undefined'){
                        get__final =  count_product;
                      }                                    
                      if(get_length == 3){
                        var get_length = parseInt(get_handle.length - i);                       
                        var get_total_count = Math.round(get__final/get_length);                                                                     
                      }else{   
                        if(i == 1){
                         var get_length = parseInt(get_handle.length - i) - 1;                       
                        }else{
                         var get_length = parseInt(get_handle.length - i);                        
                        }
                        var get_total_count = Math.ceil(get__final/get_length);                                                                     
                      }
                      var get_count_per_multi  = get_total_count;                            
                      get_final_qty_sub_get[get_handle[i]]  = get_count_per_multi;                                                                      
                      get_final_qty[get_handle[i]] = get_count_per_multi;                                                                 
                      var get_difference_checker = get_total_count;                  
                      var get__final = get_diff - get_difference_checker;
                    }                    
                  var data_layout = data,product_price = Number($(data).find('.price_off').attr('data-price')) * get_final_qty[get_handle_pro] ;                  
                  var get_subscription = Number($(data).find('.get-subscription_'+ get_selling_plan).attr('data-selling_price')) * get_final_qty[get_handle_pro],
                  get_selling_plan_name = $(data).find('.get-subscription_'+ get_selling_plan).attr('data-selling_name');
                                      
                  $('.result-products__grid').append(data_layout);                                                
                  get_price = get_price + Math.round(product_price);                       
                  get_subscription_price = get_subscription_price + get_subscription;                    
                  $('.purchase-option.one-time span.money').html(Shopify.formatMoney(get_price ,mf));
                  $('.purchase-option.purchase-option-subscription span.money').html('$' + get_subscription_price.toFixed(2));
                  $('.purchase-option-subscription .delivery-select').html(get_selling_plan_name);
                   $('.result-quantity_'+ get_handle_pro ).attr('data-quantity',get_final_qty[get_handle_pro]);                  
                  console.log(get_handle_pro,'get_total_count');
                  var get_qnt = get_final_qty[get_handle_pro]  * 2;
                  var total_hook = get_final_qty[get_handle_pro]  * 1;
                  if(total_hook > 1){
                    $('.result-products__item-quantity_'+ get_handle_pro ).html(get_qnt + ' sheets + ' + total_hook + ' hooks');                                                                                                    
                      $('.product_' + get_handle_pro +'.get-subscription_'+ get_selling_plan ).attr('data-productname',get_qnt + ' sheets + ' + total_hook + ' hooks');
                    $('.result-quantity_'+ get_handle_pro ).attr('data-product',count + ' sheets + ' + total_hook + ' hooks');
                  }else{
                    $('.result-products__item-quantity_'+ get_handle_pro ).html(get_qnt + ' sheets + 1 hook');                          
                     $('.product_' + get_handle_pro +'.get-subscription_'+ get_selling_plan ).attr('data-productname',get_qnt + ' sheets + 1 hook');
                    $('.result-quantity_'+ get_handle_pro ).attr('data-product',count + ' sheets + 1 hook');
                  }
                                     
                  $('.wrp_'+get_handle_pro).find('.get-subscription_'+ get_selling_plan ).attr('data-quantity',get_final_qty_sub_get[get_handle_pro]); 
                  $('.get-subscription_'+ get_selling_plan ).addClass('active_subscription');
                  count = count + 1;
                },
                 error:function(error) { console.log(error) }                
             });                                                                    
            }else{              
              var  get_count_per_normal = 1.00;  
              var get_final_qty_sub = 1.00;
              $.ajax({
               url: "/products/"+ get_handle[i] +"?view=ajax-quiz",
                type: "GET",                   
                contentType: "application/javascript",
                dataType : 'html', 
                async: true,
                success: function(data){                                          
                  var data_layout = data,product_price = Number($(data).find('.price_off').attr('data-price')) * get_count_per_normal;
                  var get_handle_pro = $(data).attr('data-handle'),get_subscription = Number($(data).find('.get-subscription_'+ get_selling_plan).attr('data-selling_price')) * get_count_per_normal,
                  get_selling_plan_name = $(data).find('.get-subscription_'+ get_selling_plan).attr('data-selling_name');                   
                    console.log(get_handle_pro,'elssssseeeeee');
                  setTimeout(function(){
                     $('.get_subscription_'+ get_selling_plan ).addClass('active_subscription');
                  },1000);
                  $('.result-products__grid').append(data_layout);                                                
                  get_price = get_price + Math.round(product_price);                  
                  get_subscription_price = get_subscription_price + get_subscription;                  
                  $('.purchase-option.one-time span.money').html(Shopify.formatMoney(get_price ,mf)); 
                  $('.result-products__item-quantity_'+ get_handle_pro ).find('')                  
                  $('.purchase-option.purchase-option-subscription span.money').html('$' + get_subscription_price.toFixed(2));
                  $('.purchase-option-subscription .delivery-select').html(get_selling_plan_name);
                  $('.result-quantity_'+ get_handle_pro ).attr('data-quantity',get_count_per_normal);                                    
                  var get_qnt_else = get_final_qty_sub * 2;
                  var total_hook_else = get_final_qty_sub * 1;
                  if(total_hook_else > 1){
                    $('.result-products__item-quantity_'+ get_handle_pro ).html(get_qnt_else + ' sheets + ' + total_hook_else + ' hooks');  
                    $('.product_' + get_handle_pro +'.get-subscription_'+ get_selling_plan ).attr('data-productname',get_qnt_else + ' sheets + ' + total_hook_else + ' hooks');
                    $('.result-quantity_'+ get_handle_pro ).attr('data-product',get_qnt_else + ' sheets + ' + total_hook_else + ' hooks');
                  }else{
                    $('.result-products__item-quantity_'+ get_handle_pro ).html(get_qnt_else + ' sheets + 1 hook');     
                    $('.product_' + get_handle_pro +'.get-subscription_'+ get_selling_plan ).attr('data-productname',get_qnt_else + ' sheets + 1 hook');
                    $('.result-quantity_'+ get_handle_pro ).attr('data-product',get_qnt_else + ' sheets + 1 hook');
                  }                  
                  $('.wrp_'+get_handle_pro).find('.get-subscription_'+ get_selling_plan ).attr('data-quantity',get_final_qty_sub); 
                  $('.get-subscription_'+ get_selling_plan ).addClass('active_subscription');
                },
                 error:function(error) { console.log(error) }
             }); 
            }
            count_quantity++;                                                      
        }                                  
    }else{
      $('#no_products').each(function(){    
      if($(this).val() != ''){     
        if(get_quantity ==3 ){
         get_quantity = 4.00; 
        }                      
        var get_handle = $(this).val().split(','),product_count=0;                                        
        for(var i=0;i<get_handle.length;i++){                                             
              var get_hamdle_prop = get_handle[i];                
              if(i <= count_product-1 ){                                           
                var  get_count_per = 1.00;  
                var get_final_qty = get_count_per;
                var get_final_qty_sub_else = get_count_per;
                $.ajax({
                 url: "/products/"+ get_handle[i] +"?view=ajax-quiz",
                  type: "GET",                   
                  contentType: "application/javascript",
                  dataType : 'html', 
                  async: true,
                  success: function(data){                                          
                    var data_layout = data,product_price = Number($(data).find('.price_off').attr('data-price')) * get_final_qty;                    
                    var get_handle_pro = $(data).attr('data-handle'),get_subscription = $(data).find('.get-subscription_'+ get_selling_plan).attr('data-selling_price') * get_final_qty,                                                           
                    get_selling_plan_name = $(data).find('.get-subscription_'+ get_selling_plan).attr('data-selling_name');
                    setTimeout(function(){
                      $('.get_subscription_'+ get_selling_plan ).addClass('active_subscription');
                    },1000);
                    $('.result-products__grid').append(data_layout);                                                
                    get_price = get_price + Math.round(product_price);     
                    get_subscription_price = get_subscription_price + get_subscription;                    
                    $('.purchase-option.one-time span.money').html(Shopify.formatMoney(get_price ,mf));                    
                    $('.purchase-option.purchase-option-subscription span.money').html('$' + get_subscription_price.toFixed(2));
                    $('.purchase-option-subscription .delivery-select').html(get_selling_plan_name);
                    var get_qnt_select = get_final_qty * 2;
                    var total_hook_select = get_final_qty * 1;
                    if(total_hook_select > 1){
                      $('.result-products__item-quantity_'+ get_handle_pro ).html(get_qnt_select + ' sheets + ' + total_hook_select + ' hooks');                                                                                                    
                        $('.product_' + get_handle_pro +'.get-subscription_'+ get_selling_plan ).attr('data-productname',get_qnt_select + ' sheets + ' + total_hook_select + ' hooks');
                      $('.result-quantity_'+ get_handle_pro ).attr('data-product',get_qnt_select + ' sheets + ' + total_hook_select + ' hooks');
                    }else{
                      $('.result-products__item-quantity_'+ get_handle_pro ).html(get_qnt_select + ' sheets + 1 hook');      
                      $('.product_' + get_handle_pro +'.get-subscription_'+ get_selling_plan ).attr('data-productname',get_qnt_select + ' sheets + 1 hook');
                      $('.result-quantity_'+ get_handle_pro ).attr('data-product',get_qnt_select + ' sheets + 1 hook');
                    }
                    $('.result-quantity_'+ get_handle_pro ).attr('data-quantity',get_final_qty);
                    $('.get-subscription_'+ get_selling_plan ).attr('data-quantity',get_final_qty_sub_else);
                    $('.get-subscription_'+ get_selling_plan ).addClass('active_subscription');
                  },
                   error:function(error) { console.log(error) }
               });                
          }          
        }
      }
    }); 
    }
     if(get_type_val.indexOf('spills') !== -1 || get_type_val.indexOf('counters') !== -1|| get_type_val.indexOf('appliances')!== -1 ){  
       var get_hook_spills = parseInt($('.spills_hook').attr('value'));
       count_hook = count_hook + get_hook_spills;
     }
     if(get_type_val.indexOf('dishes')!== -1){
       var get_hook_dishes = parseInt($('.dishes_hook').attr('value'));
       count_hook = count_hook + get_hook_dishes;
     }
     if(get_type_val.indexOf('messy-kids')!== -1 || get_type_val.indexOf('highchair')!== -1){ 
       var get_hook_messy = parseInt($('.messey_hook').attr('value'));
       count_hook = count_hook + get_hook_messy;         
     }
    
     // if(get_type_val.indexOf('bathroom')!== -1){ 
     //   if(get_quantity == 5){
     //     var get_quantity_five = 4;
     //   }else{
     //      var get_quantity_five = get_quantity;
     //   }
     //   count_hook = count_hook + get_quantity_five;         
     // } 
     if(get_type_val.indexOf('bathroom')!== -1){       
       if( get_quantity == 1 ){   
         var get_unit_bathroom =  parseInt($('.bathroom_hook_1').attr('value'));
         get_quantity_five = get_unit_bathroom;                   
       }
       if( get_quantity == 2 ){         
         var get_unit_bathroom =  parseInt($('.bathroom_hook_2').attr('value'));
         get_quantity_five = get_unit_bathroom;                   
       }
       if( get_quantity == 3 ){
         var get_unit_bathroom =  parseInt($('.bathroom_hook_3').attr('value'));
         get_quantity_five = get_unit_bathroom;                   
       }
       if( get_quantity >= 4 ){
         var get_unit_bathroom =  parseInt($('.bathroom_hook_4').attr('value'));
         get_quantity_five = get_unit_bathroom;                   
       }
          count_hook = count_hook + get_quantity_five; 
     }
     setTimeout(function(){      
       var get_final_hook = count_hook - count_product;
       if($('#quizContainer').attr('data-hook') != ''){
        var get_hook = $('#quizContainer').attr('data-hook');
       }else{
        var get_hook = 'papaya-hook'; 
       }
       if(get_final_hook > 0){
          $.get("/products/" + get_hook + "?view=ajax-quiz" , function(data, status){            
              var get_hook_slide = parseInt($(data).find('.price_off').attr('data-price'))/100.00;              
              var data_layout = data,get_sub_hook = get_hook_slide * get_final_hook,product_price = parseInt($(data).find('.price_off').attr('data-price')) * get_final_hook;            
              var get_handle_pro = $(data).attr('data-handle')
              $('.result-products__grid').append(data_layout);
               if(get_final_hook > 1){
                  $('.get_papaya-hook').html(get_final_hook + ' extra hooks'); 
               }else{
                  $('.get_papaya-hook').html(get_final_hook + ' extra hook'); 
               }
              get_subscription_price = get_subscription_price + get_sub_hook;                          
              get_price = get_price + Math.round(product_price);                              
              $('.purchase-option.one-time span.money').html(Shopify.formatMoney(get_price ,mf));
              $('.purchase-option.purchase-option-subscription span.money').html('$' + get_subscription_price.toFixed(2));
              $('.result-quantity_'+get_handle_pro).attr('data-quantity',get_final_hook);
            $('.get-subscription_2').attr('data-quantity',get_final_hook);
          })
        }
     },1000);
    $('.quiz-results').addClass('showed');            
     if(get_value.indexOf('messy-kids') == -1  ){        
        $('.how-to-use__item[data-title="Kid’s bathroom"]').removeClass('how-to-use__item').addClass('remove_slide');
      }
      if(get_value.indexOf('highchair') == -1 ){
        $('.how-to-use__item[data-title="Highchair"]').removeClass('how-to-use__item').addClass('remove_slide');
      }    
      if(get_name != ''){
       $('.quiz-results__name').html(get_name + '’s Bundle');
      }else{
       $('.quiz-results__name').html('Your Bundle');
      }      
       $('.how-to-use__slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          arrows: false,
          dots: true,
          slide:".how-to-use__item",
          infinite: true,
          autoplay: false,
          autoplaySpeed: 2000,
          speed: 900,
          touchThreshold: 100,      
          swipeToSlide: true,
          responsive: [
             {
              breakpoint: 1400,
              settings: {
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 641,
              settings: {
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ] 
      });
     const circleType = new CircleType(document.querySelector('.quiz-results__name'));
      circleType.radius(1400);
  }); 
  // $('.how-to-use__slider').slick({
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   centerMode: true,
  //   arrows: false,
  //   dots: true,
  //   infinite: true,
  //   autoplay: false,
  //   autoplaySpeed: 2000,
  //   speed: 900,
  //   touchThreshold: 100,      
  //   swipeToSlide: true,
  //   responsive: [
  //      {
  //       breakpoint: 1400,
  //       settings: {
  //         infinite: true,
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //       }
  //     },
  //     {
  //       breakpoint: 641,
  //       settings: {
  //         infinite: true,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       }
  //     }
  //   ] 
  // });
  

  // Add To Cart
  function addToCartSuccess() {
    $.get( "/cart?view=minicart", function(data) {
      $('.mini-cart').html(data);// 
      $(".mini-cart").removeClass("loded");
    });
  }
  $('body').on('click','.add_to_bundle',function(e){
      e.preventDefault();
      var dataID = [];      
      var get_active_optoin = $('.purchase-option.active').attr('data-option');
      if(get_active_optoin == 'one-time'){
      $('.price_off').each(function() {        
        var get_variant_id = $(this).val();                
        var get_variant_quantity = $(this).attr('data-quantity'); 
        var get_variant_name = $(this).attr('data-product'); 
        dataID.push({
          "id": get_variant_id,
          "quantity": get_variant_quantity,
          "properties":{Includes:get_variant_name}
        })
      })        
    }else{
      $('.get_subscription.active_subscription').each(function() {        
        var get_variant_id = $(this).val()
        var selling_plan = $(this).attr('data-selling_plan');
        var active_plan = $(this).attr('data-selling_number');
        var get_variant_quantity = $(this).attr('data-quantity'); 
        var get_variant_name = $(this).attr('data-productname');         
        if(active_plan > 0){
          dataID.push({
            "id": get_variant_id,
            "quantity": get_variant_quantity,
            "selling_plan": selling_plan,           
            "properties":{Includes:get_variant_name},
          })
        }else{
          dataID.push({
          "id": get_variant_id,
          "quantity": get_variant_quantity,            
        })
        }
      })   
        
    }      
     $.ajax({
      type: "POST",
      url: '/cart/add.js',      
      dataType: 'json',
      data:{items:dataID},             
      success: function(data) {
        console.info('success');
         addToCartSuccess();
        $("body, .mini-cart, .overlay").addClass("active");        
          $.getJSON('/cart.js', function(cart){
            var cartCount = cart.item_count ; 
             if(parseInt(cartCount) > 9 ){
            $('#CartCount,#CartCount__mb,#mini_cnt').addClass('has_double');    
          }else{
            $('#CartCount,#CartCount__mb,#mini_cnt').removeClass('has_double');    
          }
          if(parseInt(cartCount) > 0 ){           
          $('#CartCount').html("<span class=''>" + cartCount + "</span>").show();
          $('#CartCount__mb').html("<span class=''>" + cartCount + "</span>").show();
            }else{
           $('#CartCount,#CartCount__mb,#mini_cnt').html("<span class=''>" + cartCount + "</span>").hide(); 
          }
        }); 
      },
      error: function(error){
        console.log(error,'errorrr');
      }
    });
  });
  $('#restart_quiz').on('click',function(){      
        window.location.href = "https://www.papayareusables.com/pages/quiz";
  }); 
});
 